<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'payment'
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Payment.vue?cec07964